var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "section",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.galleryItems,
            expression: "galleryItems"
          }
        ],
        class: ["zoom-gallery", { loading: _vm.loading }],
        on: {
          click: function($event) {
            return _vm.$store.dispatch("CLOSE_GALLERY")
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "contained" },
          _vm._l(_vm.galleryItems, function(url, i) {
            return _c("super-image", {
              key: i,
              staticClass: "image",
              attrs: { src: url },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            })
          }),
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }